// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_onBoarding_parent h6{
    font-weight: 600;
}

.onboarding_heading{
    font-size: 1rem;
    font-weight: 600;
    color: #0066CC;
}

.onboarding_subheading{
    font-size: .875rem;
    font-weight: 400;
    color: #838FB4;
}

.onboarding_resetBtn{
    background: #FFFFFF;
    color: #0066CC;
    font-size: 14px;
    font-weight: 400;
    border: none;
    box-shadow: 0px 0.5px 2.5px 0px #0000004D;
}

.onboarding_resetBtn:hover{
    background: #FFFFFF;
    color: #0066CC;
}

.documentation-link {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 3px;
    color: #0066CC;
  }

.model_specific_content_container{
    border: 1px solid #838FB4;
    border-radius: 8px;
    margin-top: 10px;
    padding-bottom: 25px;
    /* padding-left: 15px; */
}
  
.model_specific_content_box{
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 10px 16px;
}

.model_specific_content_container .col-md-11  {
    width: 96% !important;
}

.model_specific_content_container .col-md-1  {
    width: 4% !important;
}

/* Toogle button start */
.addModelToggle .toggle-container {
    display: flex;
    align-items: center;
    gap: 10px;
    font-family: Arial, sans-serif;
}

.addModelToggle .label {
    font-size: 14px;
    line-height: 20px;
    color: #838FB4;
    transition: color 0.3s;
}

.addModelToggle .label.active {
    color: var(--uni_std_clr);
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
}

.addModelToggle .switch {
    width: 30px;
    height: 17px;
    background-color: #ccc;
    border-radius: 50px;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s;
}

.addModelToggle .switch.public {
    background-color: #007bff;
}

.addModelToggle .slider-circle {
    width: 13px;
    height: 13px;
    background-color: #fff;
    border-radius: 50%;
    position: absolute;
    top: 2px;
    left: 2px;
    transition: left 0.3s;
}

.addModelToggle .switch.public .slider-circle {
    left: 15px;
}
/* Toogle button end */

.modal_onBoarding_parent .form-select {
    color: #838FB4 !important;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ModelOnboarding/ModelOnboarding.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;AAEF;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;AACA,sBAAsB;;AAEtB;IACI,yBAAyB;AAC7B","sourcesContent":[".modal_onBoarding_parent h6{\n    font-weight: 600;\n}\n\n.onboarding_heading{\n    font-size: 1rem;\n    font-weight: 600;\n    color: #0066CC;\n}\n\n.onboarding_subheading{\n    font-size: .875rem;\n    font-weight: 400;\n    color: #838FB4;\n}\n\n.onboarding_resetBtn{\n    background: #FFFFFF;\n    color: #0066CC;\n    font-size: 14px;\n    font-weight: 400;\n    border: none;\n    box-shadow: 0px 0.5px 2.5px 0px #0000004D;\n}\n\n.onboarding_resetBtn:hover{\n    background: #FFFFFF;\n    color: #0066CC;\n}\n\n.documentation-link {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    text-decoration: underline;\n    cursor: pointer;\n    margin-left: 3px;\n    color: #0066CC;\n  }\n\n.model_specific_content_container{\n    border: 1px solid #838FB4;\n    border-radius: 8px;\n    margin-top: 10px;\n    padding-bottom: 25px;\n    /* padding-left: 15px; */\n}\n  \n.model_specific_content_box{\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    padding: 10px 16px;\n}\n\n.model_specific_content_container .col-md-11  {\n    width: 96% !important;\n}\n\n.model_specific_content_container .col-md-1  {\n    width: 4% !important;\n}\n\n/* Toogle button start */\n.addModelToggle .toggle-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-family: Arial, sans-serif;\n}\n\n.addModelToggle .label {\n    font-size: 14px;\n    line-height: 20px;\n    color: #838FB4;\n    transition: color 0.3s;\n}\n\n.addModelToggle .label.active {\n    color: var(--uni_std_clr);\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.addModelToggle .switch {\n    width: 30px;\n    height: 17px;\n    background-color: #ccc;\n    border-radius: 50px;\n    position: relative;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.addModelToggle .switch.public {\n    background-color: #007bff;\n}\n\n.addModelToggle .slider-circle {\n    width: 13px;\n    height: 13px;\n    background-color: #fff;\n    border-radius: 50%;\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    transition: left 0.3s;\n}\n\n.addModelToggle .switch.public .slider-circle {\n    left: 15px;\n}\n/* Toogle button end */\n\n.modal_onBoarding_parent .form-select {\n    color: #838FB4 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
